import React from 'react';
import { CircleCheck } from 'lucide-react';
import { Button } from '@/Components/shadcn';
import UIStrings from '@/Utils/UIStrings';
import { useUserSignupNavigationContext } from '@/Context/UserSignupNavigationContext';
import EmailVerifiedPageContentTypography from './EmailVerifiedPageContentTypography';

function EmailVerifiedPageContent(): React.JSX.Element {
    const { navigateToNextPage } = useUserSignupNavigationContext();

    return (
        <div className="flex flex-col items-center gap-6">
            <CircleCheck className="size-8 shrink-0 stroke-[1.25] text-emerald-600" />
            <EmailVerifiedPageContentTypography />
            <Button type="button" className="w-full" size="lg" onClick={navigateToNextPage}>
                {UIStrings.ContinueToTalentMesh}
            </Button>
        </div>
    );
}

export default EmailVerifiedPageContent;
